<rt-dropdown class="dropdown">
  @if (showHeader()) {
    <rt-dropdown-header class="header">
      <rt-icon-button
        prefix
        (click)="$event.preventDefault(); goBack($event)"
        variant="plain"
        iconName="arrow-back"
        size="small"
        shape="square"
      />
      {{ placeholderCategoryTranslationMap[category()].name }}
    </rt-dropdown-header>
  }
  @for (
    placeholder of placeholdersByCategory;
    track trackByName($index, placeholder);
    let isLast = $last
  ) {
    <rt-dropdown-item
      [insertPlaceholder]="placeholder.id"
      [insertPlaceholderTarget]="activeTarget()!"
      [isSelected]="placeholder.id === active()?.id"
      (click)="select.emit(placeholder)"
      layout-vertical
    >
      <div layout layout-space-between>
        <div layout-vertical>
          <rt-heading variant="heading">
            <span class="preserve-whitespace" margin-right-small-xx text-primary>[ </span>
            {{ withoutBrackets(placeholder.id) }}
            <span class="preserve-whitespace" margin-left-small-xx text-primary> ]</span>
          </rt-heading>
          <span
            [innerHTML]="
              placeholder.interpolated ? placeholder.value : placeholder.data.description
            "
            class="description info-dropdown-text"
          >
          </span>
        </div>
      </div>
    </rt-dropdown-item>
  }
</rt-dropdown>
